export enum IncidentStatus {
    DRAFT = 'DRAFT',
    NEW = 'NEW',
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    CLOSED_FALSE_POSITIVE = 'CLOSED_FALSE_POSITIVE',
    CLOSED_MONITOR = 'CLOSED_MONITOR',
}
